module.exports = __webpack_public_path__ + "img/lk.f54e1ef9.svg";